import { TFunction } from "i18next";

import { deCamelCase } from "../../../../utils/helpers";
import { HR_MANAGER } from "./constant";

// Backend role names → locale keys. Anything not listed falls back to the
// de-camel-cased backend name so unknown roles still render.
const ROLE_LABEL_KEYS: Record<string, string> = {
	[HR_MANAGER]: "users_role_hr-manager",
	TrainingManager: "users_role_training-manager",
	TrainingCoordinator: "users_role_training-coordinator",
	DepartmentManager: "users_role_department-manager",
	ShiftSupervisor: "users_role_shift-supervisor",
	ReadOnly: "users_role_read-only",
	LimitedAccessSupervisor: "users_role_limited-access-supervisor",
};

export const getUserRoleLabel = (roleName: string | undefined, t: TFunction): string => {
	if (!roleName) return "";
	const key = ROLE_LABEL_KEYS[roleName];
	return key ? t(key) : deCamelCase(roleName);
};
